export default __webpack_public_path__ + "static/media/search-20-px.aaf369ac.svg";